import { createFileRoute } from "@tanstack/react-router";
import { ComingSoon } from "@/components/ComingSoon";

export const Route = createFileRoute("/_authed/webhooks")({
  component: () => (
    <ComingSoon
      title="Webhooks"
      phase="Phase 9"
      summary="Outbound webhook configurations, deliveries log, and test fire."
    />
  ),
});
